/* ==========================================================================
   FLC Forge — Header (Mega Menu + Mobile Menu)
   ========================================================================== */

class MegaMenu extends HTMLElement {
  connectedCallback() {
    this.items    = this.querySelectorAll('[data-mega-item]');
    this.panels   = this.querySelectorAll('[data-mega-panel]');
    this.closeTimer = null;

    this.items.forEach(item => {
      const itemId = item.dataset.megaItem;
      const panelEl = this.querySelector(`[data-mega-panel="${itemId}"]`);

      if (!panelEl) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimer);
        this.openPanel(item, panelEl);
      });

      // Keyboard
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          panelEl?.classList.contains('is-open') ? this.closeAll() : this.openPanel(item, panelEl);
        }
        if (e.key === 'Escape') this.closeAll();
      });
    });

    this.addEventListener('mouseleave', (event) => {
      if ([...this.panels].some((panel) => panel.contains(event.relatedTarget))) return;
      this.closeTimer = setTimeout(() => this.closeAll(), 180);
    });
    this.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
    this.panels.forEach((panel) => {
      panel.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
      panel.addEventListener('mouseleave', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.closeTimer = setTimeout(() => this.closeAll(), 180);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeAll(false);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
    document.addEventListener('flc:drawers:close-all', () => this.closeAll());
  }

  openPanel(item, panel) {
    this.closeAll(false);
    if (!panel) return;
    item.setAttribute('aria-expanded', 'true');
    // make panel visible to compute dimensions
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');

    // Position panel under the triggering menu item
    try {
      const itemRect = item.getBoundingClientRect();
      const headerEl = this.closest('header') || document.querySelector('.site-header');
      const headerRect = headerEl ? headerEl.getBoundingClientRect() : { bottom: 0 };
      panel.style.position = 'fixed';
      panel.style.top = `${headerRect.bottom}px`;

      if (panel.classList.contains('mega-menu__panel--mega')) {
        panel.style.left = '0';
        panel.style.right = '0';
        panel.style.width = '100vw';
      } else {
        const panelWidth = panel.offsetWidth || Math.min(window.innerWidth, 800);
        let left = itemRect.left + (itemRect.width / 2) - (panelWidth / 2);
        left = Math.max(8, Math.min(left, window.innerWidth - panelWidth - 8));
        panel.style.left = `${left}px`;
        panel.style.right = '';
        panel.style.width = '';
      }
    } catch (e) {
      // positioning failed silently
    }

  }

  closeAll(closeOverlay = true) {
    this.items.forEach(item => item.setAttribute('aria-expanded', 'false'));
    this.panels.forEach(panel => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.left = '';
      panel.style.right = '';
      panel.style.top = '';
      panel.style.width = '';
      panel.style.position = '';
    });
    if (closeOverlay) FLC.closeOverlay();
  }
}

customElements.define('mega-menu', MegaMenu);

/* Mobile menu drawer
   ========================================================================== */
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.openBtn  = document.querySelector('[data-mobile-menu-open]');
    this.closeBtn = this.querySelector('[data-mobile-menu-close]');
    this.subMenuToggles = this.querySelectorAll('[data-sub-toggle]');

    this.openBtn?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('flc:drawers:close-all', () => this.close());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

    this.subMenuToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        const sub = btn.nextElementSibling;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !isOpen);
        sub?.classList.toggle('is-open', !isOpen);
      });
    });
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    FLC.openOverlay();
    FLC.trapFocus(this);
    document.querySelector('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    FLC.closeOverlay();
    document.querySelector('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('mobile-menu', MobileMenu);

/* Cart icon — open drawer on click
   ========================================================================== */
document.querySelector('[data-cart-icon-bubble]')?.addEventListener('click', (e) => {
  if (window.flcForge.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
    e.preventDefault();
    FLC.dispatch('flc:cart:open');
  }
});
